<!--<div  class="style_ribbon">
  <div class="style_ribbon_bloc bg-danger p-1 text-white d-flex align-items-center justify-content-center align-content-center">
    <span >MEF TEST</span>
    <span class="mx-2" style="opacity: 0.4;">|</span>
    <span >V 2.1.5</span>
  </div>
</div>-->

<header>
  <div style="position: fixed; z-index:1000; right:0; left:0;" class="p-3">
    <nav class="navbar navbar-expand-sm navbar-light bg-white p-1 col-sm-10 col-lg-6 mx-auto rounded-3 shadow-sm">
      <div class="container-fluid">
        <a href="#">
          <img class="img-fluid navbar-brand" src="assets/img/logo_andf.png" alt="logo.svg" width="50">
        </a>
        <!-- <span class="" style="width: 1px; height:40px; background-color: #DDE2ED;"></span> -->
        <button class="navbar-toggle d-lg-none border-0 bg-transparent" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <form class="d-flex flex-fill" role="search">
            <input #box [(ngModel)]="searchInput" (keyup)="inputChanged(box.value)" name="searchInput" type="text" placeholder="Rechercher par NUP ou la longitude, latitude" class="form-control border-0">
            <button (click)="oneClickSearch()" class="btn btn-light bg-white" type="submit"><i class="bi-search"></i></button>
          </form>
          <!-- <span class="" style="width: 1px; height:40px; background-color: #DDE2ED;"></span> -->
          <button class="btn btn-light bg-white" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasLegende" aria-controls="offcanvasLegende">Légende</button>
          <!-- <span class="" style="width: 1px; height:40px; background-color: #DDE2ED;"></span> -->
          <button class="btn btn-light bg-white" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasCouches" aria-controls="offcanvasLegende">Couches</button>
        </div>
      </div>
    </nav>
  </div>
  <!-- Offcanvas -->
  <div class="offcanvas offcanvas-start shadow-lg" style="width:18rem;" data-bs-scroll="true" data-bs-backdrop="false" tabindex="-1" id="offcanvasLegende" aria-labelledby="offcanvasLegendeLabel">
    <div class="offcanvas-header">
      <h5 class="" id="offcanvasLegendeLabel">Légende</h5>
      <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body">
      <div class="d-flex align-items-center mb-3" style="color:#008000;">
<!--      <div class="d-flex align-items-center mb-3" style="color:#a8b7d6;">-->
        <h4><i class="bi-circle-fill me-3"></i></h4>
        <h6 class="">Parcelles TF Etat/Communale</h6>
      </div>
      <div class="d-flex align-items-center mb-3" style="color:#90ee90;">
<!--      <div class="d-flex align-items-center mb-3" style="color:#84bc9b;">-->
        <h4><i class="bi-circle-fill me-3"></i></h4>
        <h6 class="">Parcelles TF Particulier</h6>
      </div>
      <div class="d-flex align-items-center mb-3" style="color:#FFCC89;">
<!--      <div class="d-flex align-items-center mb-3" style="color:#e3d094;">-->
        <h4><i class="bi-circle-fill me-3"></i></h4>
        <h6 class="">Parcelles avec propriétaire présumé</h6>
      </div>
      <div class="d-flex align-items-center mb-3" style="color:#C78100;">
<!--      <div class="d-flex align-items-center mb-3" style="color:#c88c8c;">-->
        <h4><i class="bi-circle-fill me-3"></i></h4>
        <h6 class="">Domaine public</h6>
      </div>
      <div class="d-flex align-items-center mb-2">
        <h4><i class="bi-circle-fill me-3" style="color:#DDEE13;"></i></h4>
        <h6 class="">Confirmation de droit en cours</h6>
      </div>

      <div class="d-flex align-items-center mb-3" style="color:#808080;">
<!--      <div class="d-flex align-items-center mb-3" style="color:#c0c0c0;">-->
        <h4><i class="bi-circle-fill me-3"></i></h4>
        <h6 class="">Parcelles sans nom</h6>
      </div>
      <hr>
      <div class="d-flex align-items-center mb-2">
        <div class="me-3">
          <div class="style_bg_img rounded-circle" style="width: 28px; height: 28px; background-image: url('assets/img/hashed_black_2.JPG');"></div>
        </div>
<!--        <h4><i class="bi-circle-fill me-3" style="background: repeating-linear-gradient(-45deg,black,black 3px,transparent 3px,transparent 8px); background-clip:text;-webkit-background-clip: text;-webkit-text-fill-color: transparent;"></i></h4>-->
        <h6 class="">Zone du Programme d'Action du Gouvernement </h6>
      </div>
      <div class="d-flex align-items-center mb-2">
        <div class="me-3">
          <div class="style_bg_img rounded-circle" style="width: 28px; height: 28px; background-image: url('assets/img/hashed_black_3.JPG');"></div>
        </div>
<!--        <h4><i class="bi-circle-fill me-3" style="background: repeating-linear-gradient(45deg,black,black 3px,transparent 3px,transparent 8px); background-clip:text;-webkit-background-clip: text;-webkit-text-fill-color: transparent;"></i></h4>-->
        <h6 class="">Zone Déclarée d'Utilité Public  </h6>
      </div>
      <div class="d-flex align-items-center mb-2">
        <div class="me-3">
          <div class="style_bg_img rounded-circle" style="width: 28px; height: 28px; background-image: url('assets/img/hashed_black_X.JPG');"></div>
        </div>
<!--        <h4><i class="bi-circle-fill me-3" style="background: repeating-linear-gradient(-45deg,black,black 3px,transparent 3px,transparent 8px), repeating-linear-gradient(45deg,black,black 3px,transparent 3px,transparent 8px);  background-clip:text;-webkit-background-clip: text;-webkit-text-fill-color: transparent;"></i></h4>-->
        <h6 class="">Zone de haute sécurité frontalière</h6>
      </div>
      <div class="d-flex align-items-center mb-2">
        <div class="me-3">
          <div class="style_bg_img rounded-circle" style="width: 28px; height: 28px; background-image: url('assets/img/patterndotblack.JPG');"></div>
        </div>
        <h6 class="">Domaine public naturel </h6>
<!--        <h4><i class="bi-circle-fill me-3" style="background: repeating-linear-gradient(0deg,black,black,transparent 3px,transparent 6px), repeating-linear-gradient(90deg,black,black,transparent 3px,transparent 6px);  background-clip:text;-webkit-background-clip: text;-webkit-text-fill-color: transparent;"></i></h4>-->
      </div>

    </div>
  </div>

  <div class="offcanvas offcanvas-start shadow-lg" style="width:18rem;" data-bs-scroll="true" data-bs-backdrop="false" tabindex="-1" id="offcanvasCouches" aria-labelledby="offcanvasCouchesLabel">
    <div class="offcanvas-header">
      <h5 class="" id="offcanvasCouchesLabel">Couches</h5>
      <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body">

      <form>
        <div class="mb-3">
          <div class="form-check">
            <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" (change)="layersCheckedOn($event.target.value)" value="osm" checked>
            <label class="form-check-label" for="exampleRadios1">
              Open Street Map
            </label>
          </div>
        </div>
        <div class="mb-3">
          <div class="form-check">
            <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" (change)="layersCheckedOn($event.target.value)" value="google">
            <label class="form-check-label" for="exampleRadios1">
              Google Maps
            </label>
          </div>
        </div>

        <div class="mb-5">
          <h6 class="mb-3"> Zone déclaré</h6>
          <div class="mb-3">
            <div class="form-check">
              <input class="form-check-input" type="checkbox"  id="flexCheckDefault" [checked]="domainePublicNaturel"
                     (change)="updateChange('dpn')">
              <label class="form-check-label" for="flexCheckDefault">
                Domaine public naturel
              </label>
            </div>
          </div>
          <div class="mb-3">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [checked]="pag"
                     (change)="updateChange('pag')">
              <label class="form-check-label" for="flexCheckChecked">
                Zone du Programme d'Action du Gouvernement
              </label>
            </div>
          </div> <div class="mb-3">
            <div class="form-check">
              <input class="form-check-input" type="checkbox"  [checked]="zdup"
                     (change)="updateChange('zdup')">
              <label class="form-check-label" for="flexCheckChecked">
                Zone Déclarée d'Utilité Public
              </label>
            </div>
          </div> <div class="mb-3">
            <div class="form-check">
              <input class="form-check-input" type="checkbox"  [checked]="zoneSecuritaire"
                     (change)="updateChange('zoneSecuritaire')">
              <label class="form-check-label" for="flexCheckChecked">
                Zone de haute sécurité frontalière
              </label>
            </div>
          </div>
        </div>
      </form>

    </div>
  </div>


</header>
